<template>
  <div class="worksbot">
    <ul>
      <li v-for="(listImg,index) in listImg" :style="{width:listImg.w+'px'}" :key="index">
        <a :href="listImg.a" target="_blank">
          <img :src="listImg.url" alt class="img" />
        </a>
        <span v-if="listImg.dis">
          <img :src="listImg.code" alt />
          <i>扫码进入小程序</i>
        </span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listImg: [
        {
          url: require("../assets/image/worksbot_img20022504.jpg?2"),
          w: 377,
          a: "http://article.photofans.cn/article-55634-1.html"
        },
        {
          url: require("../assets/image/worksbot_img20022505.jpg?2"),
          w: 434,
          a: "http://article.photofans.cn/article-55634-1.html"
        },
        {
          url: require("../assets/image/worksbot_img20022506.jpg?2"),
          w: 484,
          a: "http://article.photofans.cn/article-55634-1.html"
        },
        {
          url: require("../assets/image/worksbot_img20022507.jpg"),
          w: 460,
          a: "http://article.photofans.cn/article-55720-1.html"
        },
        {
          url: require("../assets/image/worksbot_img20022508.jpg?5"),
          w: 559,
          a: "http://article.photofans.cn/article-55720-1.html"
        },
        {
          url: require("../assets/image/worksbot_img20022509.jpg?4"),
          w: 275,
          a: "http://article.photofans.cn/article-55720-1.html"
        },
        {
          url: require("../assets/image/worksbot_img20022510.jpg?2"),
          w: 377,
          a: "http://article.photofans.cn/article-55631-1.html"
        },
        {
          url: require("../assets/image/worksbot_img20022511.jpg?2"),
          w: 434,
          a: "http://article.photofans.cn/article-55631-1.html"
        },
        {
          url: require("../assets/image/worksbot_img20022512.jpg?2"),
          w: 484,
          a: "http://article.photofans.cn/article-55631-1.html"
        },
        {
          url: require("../assets/image/worksbot_img20022501.jpg"),
          w: 460,
          a: "http://article.photofans.cn/article-55632-1.html"
        },
        {
          url: require("../assets/image/worksbot_img20022502.jpg?5"),
          w: 559,
          a: "http://article.photofans.cn/article-55632-1.html"
        },
        {
          url: require("../assets/image/worksbot_img20022503.jpg?4"),
          w: 275,
          a: "http://article.photofans.cn/article-55632-1.html"
        },
        {
          url: require("../assets/image/worksbot_img20021113.jpg?2"),
          w: 377,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1385532"
        },
        {
          url: require("../assets/image/worksbot_img20021114.jpg?2"),
          w: 434,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1385532"
        },
        {
          url: require("../assets/image/worksbot_img20021115.jpg?2"),
          w: 484,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1385532"
        },
        {
          url: require("../assets/image/worksbot_img20021110.jpg"),
          w: 460,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1385532"
        },
        {
          url: require("../assets/image/worksbot_img20021111.jpg?5"),
          w: 559,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1385532"
        },

        {
          url: require("../assets/image/worksbot_img20021112.jpg?4"),
          w: 275,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1385532"
        },
        {
          url: require("../assets/image/worksbot_img20021101.jpg?2"),
          w: 377,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1381856"
        },
        {
          url: require("../assets/image/worksbot_img20021102.jpg?2"),
          w: 434,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1381856"
        },
        {
          url: require("../assets/image/worksbot_img20021103.jpg?2"),
          w: 484,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1381856"
        },
        {
          url: require("../assets/image/worksbot_img20021104.jpg"),
          w: 460,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1377602"
        },
        {
          url: require("../assets/image/worksbot_img20021105.jpg?5"),
          w: 559,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1377602"
        },

        {
          url: require("../assets/image/worksbot_img20021106.jpg?4"),
          w: 275,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1377602"
        },
        {
          url: require("../assets/image/worksbot_img20021107.jpg?2"),
          w: 377,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1384257"
        },
        {
          url: require("../assets/image/worksbot_img20021108.jpg?2"),
          w: 434,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1384257"
        },
        {
          url: require("../assets/image/worksbot_img20021109.jpg?2"),
          w: 484,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1384257"
        },

        {
          url: require("../assets/image/worksbot_img19122404.jpg"),
          w: 460,
          a: "http://article.photofans.cn/article-55273-1.html"
        },
        {
          url: require("../assets/image/worksbot_img19122405.jpg?5"),
          w: 559,
          a: "http://article.photofans.cn/article-55272-1.html"
        },

        {
          url: require("../assets/image/worksbot_img19122406.jpg?4"),
          w: 275,
          a: "http://article.photofans.cn/article-55273-1.html"
        },
        {
          url: require("../assets/image/worksbot_img19122401.jpg?2"),
          w: 377,
          a: "http://article.photofans.cn/article-55272-1.html"
        },
        {
          url: require("../assets/image/worksbot_img19122402.jpg?2"),
          w: 434,
          a: "http://article.photofans.cn/article-55274-1.html"
        },
        {
          url: require("../assets/image/worksbot_img19122403.jpg?2"),
          w: 484,
          a: "http://article.photofans.cn/article-55274-1.html"
        },
        {
          url: require("../assets/image/worksbot_img19121304.jpg"),
          w: 460,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1348726"
        },
        {
          url: require("../assets/image/worksbot_img19121305.jpg?5"),
          w: 559,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1348726"
        },

        {
          url: require("../assets/image/worksbot_img19121306.jpg?4"),
          w: 275,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1348726"
        },
        {
          url: require("../assets/image/worksbot_img19121301.jpg?2"),
          w: 377,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1356964"
        },
        {
          url: require("../assets/image/worksbot_img19121302.jpg?2"),
          w: 434,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1356964"
        },
        {
          url: require("../assets/image/worksbot_img19121303.jpg?2"),
          w: 484,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1356964"
        },
        {
          url: require("../assets/image/worksbot_img19121107.jpg"),
          w: 460,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1350468"
        },

        {
          url: require("../assets/image/worksbot_img19121108.jpg?5"),
          w: 559,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1350468"
        },

        {
          url: require("../assets/image/worksbot_img19121109.jpg?4"),
          w: 275,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1350468"
        },
        {
          url: require("../assets/image/worksbot_img19121104.jpg?2"),
          w: 377,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1355451"
        },
        {
          url: require("../assets/image/worksbot_img19121105.jpg?2"),
          w: 434,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1355451"
        },
        {
          url: require("../assets/image/worksbot_img19121106.jpg?2"),
          w: 484,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1355451"
        },

        {
          url: require("../assets/image/worksbot_img19121101.jpg"),
          w: 460,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1347992"
        },

        {
          url: require("../assets/image/worksbot_img19121102.jpg?5"),
          w: 559,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1347992"
        },

        {
          url: require("../assets/image/worksbot_img19121103.jpg?4"),
          w: 275,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1347992"
        },
        {
          url: require("../assets/image/worksbot_img19112801.jpg?2"),
          w: 377,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1348242"
        },
        {
          url: require("../assets/image/worksbot_img19112519.jpg?2"),
          w: 434,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1341560"
        },
        {
          url: require("../assets/image/worksbot_img19112514.jpg?2"),
          w: 484,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1341560"
        },
        {
          url: require("../assets/image/worksbot_img1.jpg?6"),
          w: 460,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346367"
        },

        {
          url: require("../assets/image/worksbot_img2.jpg?5"),
          w: 559,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346367"
        },

        {
          url: require("../assets/image/worksbot_img3.jpg?4"),
          w: 275,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1345497"
        },
        {
          url: require("../assets/image/worksbot_img19112506.jpg?2"),
          w: 377,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339139"
        },
        {
          url: require("../assets/image/worksbot_img19112804.jpg?2"),
          w: 434,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1348242"
        },
        {
          url: require("../assets/image/worksbot_img19112503.jpg?2"),
          w: 484,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339139"
        },
        {
          url: require("../assets/image/worksbot_img13.jpg?2"),
          w: 460,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346367"
        },
        {
          url: require("../assets/image/worksbot_img8.jpg?2"),
          w: 559,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1345551"
        },
        {
          url: require("../assets/image/worksbot_img19112511.jpg?2"),
          w: 275,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346367"
        },
        {
          url: require("../assets/image/worksbot_img19112512.jpg?2"),
          w: 377,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339278"
        },
        {
          url: require("../assets/image/worksbot_img19112513.jpg?2"),
          w: 434,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346085"
        },

        {
          url: require("../assets/image/worksbot_img19112803.jpg?2"),
          w: 484,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1348242"
        },
        {
          url: require("../assets/image/worksbot_img19112515.jpg?2"),
          w: 460,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1341560"
        },
        {
          url: require("../assets/image/worksbot_img19112516.jpg?2"),
          w: 559,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339278"
        },
        {
          url: require("../assets/image/worksbot_img19112517.jpg?2"),
          w: 275,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346085"
        },
        {
          url: require("../assets/image/worksbot_img19112518.jpg?2"),
          w: 377,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346085"
        },

        {
          url: require("../assets/image/worksbot_img19112802.jpg?2"),
          w: 434,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1348242"
        },
        {
          url: require("../assets/image/worksbot_img19112520.jpg?2"),
          w: 484,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346367"
        },
        {
          url: require("../assets/image/worksbot_img19112521.jpg?2"),
          w: 460,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1345551"
        },
        {
          url: require("../assets/image/worksbot_img19112522.jpg?2"),
          w: 559,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339278"
        },
        {
          url: require("../assets/image/worksbot_img19112523.jpg?2"),
          w: 275,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1345497"
        },
        {
          url: require("../assets/image/worksbot_img19112524.jpg?2"),
          w: 377,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1341560"
        },
        {
          url: require("../assets/image/worksbot_img19112525.jpg?2"),
          w: 434,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346367"
        },
        {
          url: require("../assets/image/worksbot_img19112526.jpg?2"),
          w: 484,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346085"
        },
        {
          url: require("../assets/image/worksbot_img19112527.jpg?2"),
          w: 460,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346367"
        },
        {
          url: require("../assets/image/worksbot_img19112528.jpg?2"),
          w: 559,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1345551"
        },
        {
          url: require("../assets/image/worksbot_img19112529.jpg?2"),
          w: 275,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339278"
        },
        {
          url: require("../assets/image/worksbot_img19112530.jpg?2"),
          w: 377,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1335909"
        },
        {
          url: require("../assets/image/worksbot_img19112531.jpg?2"),
          w: 434,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339278"
        },
        {
          url: require("../assets/image/worksbot_img19112532.jpg?2"),
          w: 484,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1341560"
        },
        {
          url: require("../assets/image/worksbot_img19112533.jpg?2"),
          w: 460,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339139"
        },
        {
          url: require("../assets/image/worksbot_img19112534.jpg?2"),
          w: 559,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346367"
        },
        {
          url: require("../assets/image/worksbot_img19112535.jpg?2"),
          w: 275,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1341560"
        },
        {
          url: require("../assets/image/worksbot_img19112536.jpg?2"),
          w: 377,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346085"
        },
        {
          url: require("../assets/image/worksbot_img19112537.jpg?2"),
          w: 434,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346367"
        },
        {
          url: require("../assets/image/worksbot_img19112538.jpg?2"),
          w: 484,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1335909"
        },
        {
          url: require("../assets/image/worksbot_img19112539.jpg?2"),
          w: 460,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1341560"
        },
        {
          url: require("../assets/image/worksbot_img19112540.jpg?2"),
          w: 559,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1341560"
        },
        {
          url: require("../assets/image/worksbot_img19112541.jpg?2"),
          w: 275,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339278"
        },
        {
          url: require("../assets/image/worksbot_img19112542.jpg?2"),
          w: 377,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339278"
        },
        {
          url: require("../assets/image/worksbot_img19112507.jpg?2"),
          w: 434,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339139"
        },
        {
          url: require("../assets/image/worksbot_img19112544.jpg?2"),
          w: 484,
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339278"
        }
        // {
        //   url: require("../assets/image/worksbot_img19112545.jpg?2"),
        //   w: 460,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1335909"
        // },
        // {
        //   url: require("../assets/image/worksbot_img19112546.jpg?2"),
        //   w: 559,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346367"
        // },
        // {
        //   url: require("../assets/image/worksbot_img19112547.jpg?2"),
        //   w: 275,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1341560"
        // },

        // {
        //   url: require("../assets/image/worksbot_img4.jpg?4"),
        //   w: 377,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1353579"
        // },
        // {
        //   url: require("../assets/image/worksbot_img5.jpg?2"),
        //   w: 434,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1342707"
        // },
        // {
        //   url: require("../assets/image/worksbot_img6.jpg?2"),
        //   w: 484,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1345551"
        // },
        // {
        //   url: require("../assets/image/worksbot_img7.jpg?2"),
        //   w: 460,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1342292"
        // },
        // {
        //   url: require("../assets/image/worksbot_img19112505.jpg?2"),
        //   w: 559,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339139"
        // },
        // {
        //   url: require("../assets/image/worksbot_img9.jpg?2"),
        //   w: 275,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1342707"
        // }
        // {
        //   url: require("../assets/image/worksbot_img19112501.jpg?2"),
        //   w: 377,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1341560"
        // },

        // {
        //   url: require("../assets/image/worksbot_img11.jpg?2"),
        //   w: 434,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1345551"
        // },
        // {
        //   url: require("../assets/image/worksbot_img12.jpg?2"),
        //   w: 484,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346085"
        // },
        // {
        //   url: require("../assets/image/worksbot_img19112508.jpg?2"),
        //   w: 460,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339139"
        // },

        // {
        //   url: require("../assets/image/worksbot_img14.jpg?2"),
        //   w: 559,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346367"
        // },
        // {
        //   url: require("../assets/image/worksbot_img15.jpg?2"),
        //   w: 275,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346367"
        // },
        // {
        //   url: require("../assets/image/worksbot_img19120203.jpg?2"),
        //   w: 377,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1351322"
        // },

        // {
        //   url: require("../assets/image/worksbot_img19120202.jpg?2"),
        //   w: 434,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1351322"
        // },
        // {
        //   url: require("../assets/image/worksbot_img19120201.jpg?2"),
        //   w: 484,
        //   a:
        //     "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1351322"
        // }
      ]
    };
  }
};
</script>
<style scoped>
.worksbot {
  float: left;
  margin-top: 10px;
  width: 1300px;
}
.worksbot ul,
.worksbot ul li,
.worksbot ul li .img {
  float: left;
}
.worksbot ul {
  width: 102%;
}

.worksbot ul li {
  position: relative;
  left: -7px;
  height: 307px;
  margin: 0 10px 5px 0;
  overflow: hidden;
}
.worksbot ul li:nth-child(3n) {
  margin-right: 0;
}
.worksbot ul li:nth-child(n + 4) {
  margin-top: 5px;
}
.worksbot ul li span {
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: block;
  right: 0;
  top: 0;
  background: linear-gradient(
    180deg,
    transparent 0,
    rgba(0, 0, 0, 0) 10%,
    rgba(0, 0, 0, 0.1) 30%,
    rgba(0, 0, 0, 0.2) 40%,
    rgba(0, 0, 0, 0.3) 60%,
    rgba(0, 0, 0, 0.5) 80%,
    rgba(0, 0, 0, 0.7)
  );
  background: -webkit-linear-gradient(
    180deg,
    transparent 0,
    rgba(0, 0, 0, 0) 10%,
    rgba(0, 0, 0, 0.1) 30%,
    rgba(0, 0, 0, 0.2) 40%,
    rgba(0, 0, 0, 0.3) 60%,
    rgba(0, 0, 0, 0.5) 80%,
    rgba(0, 0, 0, 0.7)
  );
  background: -moz-linear-gradient(
    180deg,
    transparent 0,
    rgba(0, 0, 0, 0) 10%,
    rgba(0, 0, 0, 0.1) 30%,
    rgba(0, 0, 0, 0.2) 40%,
    rgba(0, 0, 0, 0.3) 60%,
    rgba(0, 0, 0, 0.5) 80%,
    rgba(0, 0, 0, 0.7)
  );
  background: -o-linear-gradient(
    180deg,
    transparent 0,
    rgba(0, 0, 0, 0) 10%,
    rgba(0, 0, 0, 0.1) 30%,
    rgba(0, 0, 0, 0.2) 40%,
    rgba(0, 0, 0, 0.3) 60%,
    rgba(0, 0, 0, 0.5) 80%,
    rgba(0, 0, 0, 0.7)
  );
  background: -ms-linear-gradient(
    180deg,
    transparent 0,
    rgba(0, 0, 0, 0) 10%,
    rgba(0, 0, 0, 0.1) 30%,
    rgba(0, 0, 0, 0.2) 40%,
    rgba(0, 0, 0, 0.3) 60%,
    rgba(0, 0, 0, 0.5) 80%,
    rgba(0, 0, 0, 0.7)
  );
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  -ms-transition: all 0.3s;
  opacity: 0;
}
.worksbot ul li span:hover {
  opacity: 1;
}
.worksbot ul li span i {
  position: absolute;
  bottom: 10px;
  transform: translateY(20px);
  -webkit-transform: translateY(20px);
  -moz-transform: translateY(20px);
  -ms-transform: translateY(20px);
  -o-transform: translateY(20px);
  transition: all 0.3s 0.4s;
  -webkit-transition: all 0.3s 0.4s;
  -moz-transition: all 0.3s 0.4s;
  -ms-transition: all 0.3s 0.4s;
  -o-transition: all 0.3s 0.4s;
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #fff;
  opacity: 0;
}
.worksbot ul li span:hover i {
  opacity: 1;
  transform: translateY(-45px);
  -webkit-transform: translateY(-45px);
  -moz-transform: translateY(-45px);
  -ms-transform: translateY(-45px);
  -o-transform: translateY(-45px);
}
.worksbot ul li span:hover img {
  width: 100%;
  right: 50%;
  bottom: 50%;
  opacity: 1;
  transform: translate(50%, 50%);
  -webkit-transform: translate(50%, 50%);
  -moz-transform: translate(50%, 50%);
  -ms-transform: translate(50%, 50%);
  -o-transform: translate(50%, 50%);
}
.worksbot ul li span img {
  position: absolute;
  transform: translateX(50%);
  -webkit-transform: translateX(50%);
  -moz-transform: translateX(50%);
  -ms-transform: translateX(50%);
  -o-transform: translateX(50%);
  right: 50%;
  bottom: 10%;
  width: 100%;
  opacity: 0;
  max-width: 140px;
  transition: all 0.3s 0.4s;
  -moz-transition: all 0.3s 0.4s;
  -webkit-transition: all 0.3s 0.4s;
  -ms-transition: all 0.3s 0.4s;
  -o-transition: all 0.3s 0.4s;
}

.worksbot ul li .img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /* width: 100%; */
  height: 100%;
  transition: all 1s;
}
.worksbot ul li:hover .img {
  height: 105%;
}
</style>